(function () {
  if (window.__freeItemRules) return;
  window.__freeItemRules = true;

  const dataEl = document.getElementById('free-item-rules-data');
  if (!dataEl) return;

  let config;
  try {
    config = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  const rules = (config.rules || []).filter((rule) => rule && rule.id);
  if (rules.length === 0) return;

  // Hidden line property that marks a free line. The underscore keeps it out of the cart display.
  const FREE_PROP = '_free_item';
  const post = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((response) => response.json());
  const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());

  // "YYYY-MM-DD HH:MM" in the configured timezone, so strings compare in order.
  function nowInTimezone() {
    const format = (timeZone) =>
      new Intl.DateTimeFormat('sv-SE', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      })
        .format(new Date())
        .replace(',', '');
    try {
      return format(config.timezone || 'Asia/Beirut');
    } catch (e) {
      return format(undefined);
    }
  }

  function normalize(value, endOfDay) {
    const v = (value || '').trim().replace('T', ' ');
    if (!v) return '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return `${v} ${endOfDay ? '23:59' : '00:00'}`;
    return v.slice(0, 16);
  }

  function isActive(rule) {
    const now = nowInTimezone();
    const start = normalize(rule.start, false);
    const end = normalize(rule.end, true);
    if (start && now < start) return false;
    if (end && now > end) return false;
    return true;
  }

  const isFreeLine = (item) => !!(item.properties && item.properties[FREE_PROP]);

  // Work out what has to change so every active rule's free line matches what was bought.
  // Shopify can show one free line as several lines (it splits discounted units from the rest), so the
  // free quantity is counted across all of them and changes use the line number (highest first).
  function planChanges(cart) {
    const changes = [];
    const adds = [];
    const activeRules = rules.filter(isActive);
    const activeIds = new Set(activeRules.map((rule) => rule.id));

    // Free lines of a rule that is off / expired / removed go away.
    cart.items.forEach((item, index) => {
      if (isFreeLine(item) && !activeIds.has(item.properties[FREE_PROP])) changes.push({ line: index + 1, quantity: 0 });
    });

    activeRules.forEach((rule) => {
      const buyHandles = new Set(rule.buyHandles);
      const bought = cart.items
        .filter((item) => !isFreeLine(item) && buyHandles.has(item.handle))
        .reduce((sum, item) => sum + item.quantity, 0);
      const wanted = Math.floor(bought / rule.buyQty) * rule.freeQty;

      const freeLines = [];
      cart.items.forEach((item, index) => {
        if (isFreeLine(item) && item.properties[FREE_PROP] === rule.id && item.variant_id === rule.freeVariantId) {
          freeLines.push({ line: index + 1, quantity: item.quantity });
        }
      });
      const have = freeLines.reduce((sum, line) => sum + line.quantity, 0);
      if (have === wanted) return;

      if (wanted > have) {
        if (freeLines.length > 0) changes.push({ line: freeLines[0].line, quantity: freeLines[0].quantity + (wanted - have) });
        else adds.push({ id: rule.freeVariantId, quantity: wanted, properties: { [FREE_PROP]: rule.id } });
      } else {
        let remaining = wanted;
        freeLines.forEach((line) => {
          const keep = Math.min(line.quantity, remaining);
          remaining -= keep;
          if (keep !== line.quantity) changes.push({ line: line.line, quantity: keep });
        });
      }
    });

    // Highest line number first so earlier changes don't shift the lines still to be changed.
    changes.sort((x, y) => y.line - x.line);
    const ops = changes.map((change) => ({ url: '/cart/change.js', body: change }));
    if (adds.length > 0) ops.push({ url: '/cart/add.js', body: { items: adds } });
    return ops;
  }

  // One sync at a time, in order. Returns a promise so "Buy it now" can wait for it.
  let chain = Promise.resolve();
  let waiting = 0;
  function sync(knownCart) {
    // A cart from the theme's own event is only used when nothing else is queued (it could be out of date).
    const cart = waiting === 0 ? knownCart : undefined;
    waiting += 1;
    chain = chain.then(() => runSync(cart)).catch(() => {}).then(() => {
      waiting -= 1;
    });
    return chain;
  }

  async function runSync(knownCart) {
    try {
      const cart = knownCart && Array.isArray(knownCart.items) ? knownCart : await getCart();
      const ops = planChanges(cart);

      if (ops.length > 0) {
        // Ask the theme which sections show the cart, so the last request can return them already rendered.
        const sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
        );

        let rendered = {};
        let failed = false;
        for (let i = 0; i < ops.length; i++) {
          const body = Object.assign({}, ops[i].body);
          if (i === ops.length - 1 && sections.length > 0) body.sections = sections;
          const result = await post(ops[i].url, body);

          if (result && result.status) {
            // e.g. not enough stock for the free item: leave the cart as it is and tell the customer.
            failed = true;
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
              source: 'free-item-rules',
              errors: result.errors || result.description,
              message: result.message,
            });
            break;
          }
          if (result && result.sections) rendered = result.sections;
        }

        if (!failed) {
          const updated = await getCart();
          updated.sections = rendered;
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: updated, source: 'free-item-rules' });
        }
      }
    } catch (e) {
      console.error('free-item-rules', e);
    }
  }

  // "Buy it now" skips the cart, so the free item would never be added. For a product that has an
  // active rule, add it to the cart ourselves, let the rule add the free item, then go to checkout.
  function productHandleFromPage() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  let buyNowBypass = false;
  document.addEventListener(
    'click',
    async (event) => {
      const button = event.target.closest && event.target.closest('.shopify-payment-button__button--unbranded');
      if (!button || buyNowBypass) return;

      const handle = productHandleFromPage();
      if (!handle || !rules.some((rule) => isActive(rule) && rule.buyHandles.includes(handle))) return;

      const form = button.closest('form') || document.querySelector('form[action*="/cart/add"]');
      const idInput = form && form.querySelector('[name="id"]');
      if (!form || !idInput || !idInput.value) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      button.disabled = true;

      try {
        const data = new FormData(form);
        const properties = {};
        data.forEach((value, key) => {
          const m = key.match(/^properties\[(.+)\]$/);
          if (m && value !== '') properties[m[1]] = value;
        });
        const item = { id: Number(idInput.value), quantity: Number(data.get('quantity') || 1), properties };
        const result = await post('/cart/add.js', { items: [item] });
        if (result && result.status) throw new Error(result.description || 'add failed');
        await sync();
        window.location.href = '/checkout';
      } catch (e) {
        // Anything unexpected: hand the click back to Shopify's own Buy it now button.
        console.error('free-item-rules', e);
        button.disabled = false;
        buyNowBypass = true;
        button.click();
        buyNowBypass = false;
      }
    },
    true
  );

  function start() {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === 'free-item-rules') return; // our own update
      if (event && event.cart && event.cart.errors) return;
      sync(event && event.cart);
    });
    sync();
  }

  if (window.FoxTheme && FoxTheme.pubsub) start();
  else window.addEventListener('DOMContentLoaded', () => window.FoxTheme && FoxTheme.pubsub && start());
})();
